import { SVGProps } from "react";
const ReportCommentSvg = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" fill="none" {...props}>
    <path
      d="M3.33333 13.9991V2.61914"
      stroke="#CE212B"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M12.6673 9.34602V2.66602"
      stroke="#CE212B"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M3.33398 9.33428C3.33398 9.33428 3.91732 8.84961 5.66732 8.84961C7.41732 8.84961 8.58398 10.0009 10.334 10.0009C12.084 10.0009 12.6673 9.34961 12.6673 9.34961"
      stroke="#CE212B"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M3.33398 2.62133C3.33398 2.62133 3.91732 2 5.66732 2C7.41732 2 8.58398 3.15133 10.334 3.15133C12.084 3.15133 12.6673 2.66667 12.6673 2.66667"
      stroke="#CE212B"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
);
export default ReportCommentSvg;
